import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import hydrationLevelWebm from '@/assets/landing-videos/water-fasting-male.webm'

const schema: LandingScreenSchema = {
	order: [
		'LandingHead',
		'LandingTitle',
		'LandingSubtitle',
		'LandingVideoAnimation',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_funnel.pages.landing.title_weight_loss'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			title: $t('water_fasting_f.hydration_block.title'),
			uppercase: true,
		}),

		LandingVideoAnimation: (): LandingComponentsConfig['LandingVideoAnimation'] => ({
			url: hydrationLevelWebm,
			loop: true,
			customStyles: {
				height: '40vh',
				marginBottom: 'var(--size-32)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
